export const MERCHANT_WORKSPACE_UPDATED_EVENT = "mozzoapp:merchant-workspace-updated";

const isId = (value) => typeof value === "string" && value.trim().length > 0;

export const isMerchantWorkspaceUpdateForUser = (detail, user, authenticatedUserId) =>
  Boolean(
    isId(detail?.branchId) &&
    isId(detail?.userId) &&
    detail.userId === user?.id &&
    detail.userId === authenticatedUserId
  );

export const emitMerchantWorkspaceUpdate = ({ branchId, userId } = {}) => {
  if (typeof window === "undefined" || !isId(branchId) || !isId(userId)) return false;
  window.dispatchEvent(new CustomEvent(MERCHANT_WORKSPACE_UPDATED_EVENT, {
    detail: { branchId, userId },
  }));
  return true;
};

export const subscribeToMerchantWorkspaceUpdates = (listener) => {
  if (typeof window === "undefined") return () => {};
  const onUpdate = (event) => listener(event.detail);
  window.addEventListener(MERCHANT_WORKSPACE_UPDATED_EVENT, onUpdate);
  return () => window.removeEventListener(MERCHANT_WORKSPACE_UPDATED_EVENT, onUpdate);
};
